import React from 'react';
import { useGroupsListTableInit } from './useGroupsListTableInit';
import { useGroupsListTableState } from './useGroupsListTableState';
import { useGroupsListStore } from '../pagehooks/useGroupsListStore';
import TableTop from '../../../../core/table/TableTop';
import TableBody from '../../../../core/table/TableBody';
import TablePaging from '../../../../core/table/TablePaging';
import { useGroupsData } from './useGroupsData';
import TableCreateEntityButton from '../../../../core/table/TableCreateEntityButton';
import TableHead from '../../../../core/table/TableHead';
import { ngDelegate } from '../../../../core/services/ng.delegate';
import TableList from '../../../../core/table/TableList';

export const groupsListTableId = 'adminGroupsList';

const GroupsListTable = (): JSX.Element => {
    const { init } = useGroupsListTableInit();

    return init ? <></> : <TableWrapper />;
};

const TableWrapper = (): JSX.Element => {
    const { canEdit, routeToCreate, routeToEdit } = useGroupsListStore();
    const { fltStats, paging, cols, sections, sort, filters, setFilter, setSort, setPaging, waiting } =
        useGroupsListTableState();
    const { items } = useGroupsData();

    if (waiting) {
        ngDelegate.wait(true, true);
        return <></>;
    } else {
        ngDelegate.wait(false, true);
    }

    return (
        <TableList>
            <TableTop
                id={groupsListTableId}
                fltStats={fltStats}
                topRight={
                    canEdit ? (
                        <TableCreateEntityButton
                            id="adminGroupsSearch"
                            onClick={routeToCreate}
                        />
                    ) : null
                }
            />
            <table>
                <TableHead
                    cols={cols}
                    sections={sections}
                    sort={sort}
                    filters={filters}
                    setFilter={setFilter}
                    setSort={setSort}
                />
                <TableBody
                    cols={cols}
                    rows={items}
                    onClick={routeToEdit}
                />
            </table>
            <TablePaging
                paging={paging}
                setPaging={setPaging}
                fltStats={fltStats}
            />
        </TableList>
    );
};

export default GroupsListTable;
